var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-artist"},[_c('img',{attrs:{"src":_vm.artist.image[3]['#text']}}),_c('h2',[_c('a',{attrs:{"href":_vm.artist.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.artist.name))])]),_c('p',{staticClass:"listeners"},[_vm._v(_vm._s(_vm.artist.listeners)+" "+_vm._s(_vm._f("pluralize")(_vm.artist.listeners,'es', ['oyente', 'oyentes'])))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a4bbfea","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Artist.vue
// module id = 20
// module chunks = 0